import { clearStoredAuthSession, getStoredAuthSession, setStoredAuthSession } from "@/services/auth-storage";

import type { User } from "../types";

export interface LoginPayload {
  email: string;
  password: string;
}

const mockUsers: User[] = [
  {
    id: "demo-admin",
    email: "admin@esmartcamera.local",
    name: "Administrator",
    role: "admin",
    permissions: ["dashboard", "monitoring", "playback", "devices", "events", "settings"],
  },
  {
    id: "demo-operator",
    email: "operator@esmartcamera.local",
    name: "Operator",
    role: "operator",
    permissions: ["monitoring", "events"],
  },
];

export class MockAuthService {
  async login(payload: LoginPayload): Promise<User> {
    const user = mockUsers.find((item) => item.email === payload.email);

    if (!user || payload.password.length < 1) {
      throw new Error("Invalid credentials");
    }

    setStoredAuthSession({ userId: user.id, permissions: user.permissions });
    return { ...user };
  }

  async logout(): Promise<void> {
    clearStoredAuthSession();
  }

  async getCurrentUser(): Promise<User | null> {
    const session = getStoredAuthSession();
    if (!session?.userId) {
      return null;
    }

    return mockUsers.find((user) => user.id === session.userId) ?? null;
  }
}

export const mockAuthService = new MockAuthService();
